// extracted by mini-css-extract-plugin
export var enter = "page-module--enter--d5d98";
export var enterActive = "page-module--enterActive--8f179";
export var enterDone = "page-module--enterDone--1e252";
export var exit = "page-module--exit--935d3";
export var exitActive = "page-module--exitActive--9c539";
export var layout = "page-module--layout--8e9d6";
export var main = "page-module--main--1ea34";
export var sideBarContainer = "page-module--sideBarContainer--e7729";